import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import ProductSearchPage from '@features/admin/product-search/ProductSearchPage.tsx';
import { useProductSearchStore } from '@features/admin/product-search/productSearchStore';

const productSearchSchema = z.object({
  q: z.string().optional(),
  categoryEcid: z.coerce.string().optional(),
  page: z.coerce.number().optional(),
  size: z.coerce.number().optional(),
});

export const Route = createFileRoute('/admin/products/')({
  validateSearch: search => productSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: async ({ search }) => {
    const store = useProductSearchStore.getState();
    await store.loadCategoryCache();
    await store.fetchProducts({
      categoryEcid: search.categoryEcid,
      name: search.q,
      page: search.page || 1,
      size: search.size || 20,
    });
  },
});

function RouteComponent() {
  return <ProductSearchPage />;
}
